








































































































































import {
  ref,
  defineComponent,
  computed,
  useRouter,
  useContext,
  useFetch,
} from "@nuxtjs/composition-api";
import { useUserOrder } from "~/modules/customer/composables/useUserOrder";
import { CustomerOrderListResults } from "~/modules/customer/composables/useUserOrder/useUserOrder";
import { useCustomerStore } from "~/modules/customer/stores/customer";
import { convertTime } from "~/helpers";
import HeaderAccountMobile from "~/components/Header/HeaderAccountMobile.vue";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";

export default defineComponent({
  name: "OrderHistory",
  components: {
    HeaderAccountMobile,
    SkeletonLoader,
  },
  setup() {
    const router = useRouter();
    const { app } = useContext();
    const { listOrderByFilter, error, loading } = useUserOrder();
    const { user } = useCustomerStore();

    const phoneLogin = computed(() => user?.phone_number);
    const customerId = computed(() => user?.customer_id);
    const orders = ref<CustomerOrderListResults | null>(null);
    const totalOrder = ref(0);
    const currentPage = ref(1);
    const itemsPerPage = 5;
    const loadedPages = ref<Record<number, CustomerOrderListResults>>({});

    const totalPages = computed(() => {
      return Math.ceil(totalOrder.value / itemsPerPage);
    });

    useFetch(async () => {
      if (phoneLogin.value && customerId.value) {
        const params = {
          phone_number: phoneLogin.value,
          customerId: customerId.value,
          limit: itemsPerPage,
          offset: 0,
        };
        orders.value = await listOrderByFilter(params);
        totalOrder.value = orders.value?.total_count || 0;
        if (orders.value) {
          loadedPages.value[1] = orders.value;
        }
      }
    });

    const loadOrderByPage = async (page) => {
      if (phoneLogin.value && customerId.value) {
        if (loadedPages.value[page]) {
          orders.value = loadedPages.value[page];
          return;
        }

        const params = {
          phone_number: phoneLogin.value,
          customerId: customerId.value,
          limit: itemsPerPage,
          offset: itemsPerPage * (page - 1),
        };
        orders.value = await listOrderByFilter(params);

        if (orders.value) {
          loadedPages.value[page] = orders.value;
        }
      }
    };

    const goToPage = (page) => {
      if (page !== currentPage.value && page > 0 && page <= totalPages.value) {
        currentPage.value = page;
        loadOrderByPage(page);
      }
    };

    const changeTime = (time) => {
      return convertTime(time);
    };

    const checkOrderStatus = (status, payment_method, type = "status") => {
      switch (status) {
        case "Created":
          if (type == "status") {
            return "Đang xử lý";
          }

          return "processing";
        case "Validated":
          if (type == "status") {
            return "Đang xử lý";
          }

          return "processing";
        case "To be Prepared":
          if (type == "status") {
            return "Đang vận chuyển";
          }

          return "processing";
        case "Ready for pickup":
          if (type == "status") {
            return "Đã có hàng";
          }

          return "processing";
        case "Prepared":
          if (type == "status") {
            return "Đang vận chuyển";
          }

          return "shipping";
        case "Package given to carrier":
          if (type == "status") {
            return "Đã giao";
          }

          return "delivered";
        case "complete":
          if (type == "status") {
            return "Đã giao";
          }

          return "delivered";
        case "Cancel":
          if (type == "status") {
            return "Đã hủy";
          }

          return "cancel";
        case "Pending":
          if (type == "status") {
            if (payment_method !== "cashondelivery") {
              return "Chờ thanh toán";
            } else {
              return "Đang xử lý";
            }
          } else {
            if (payment_method !== "cashondelivery") {
              return "waiting";
            } else {
              return "processing";
            }
          }
        default:
          if (type == "status") {
            return "Đang xử lý";
          }

          return "processing";
      }
    };

    const getStatusClass = (status) => {
      switch (status) {
        case "Created":
          return "order-item__status--waiting";
        case "Validated":
        case "To be Prepared":
          return "order-item__status--processing";
        case "Prepared":
          return "order-item__status--shipping";
        case "Package given to carrier":
        case "complete":
          return "order-item__status--delivered";
        case "Cancel":
          return "order-item__status--cancel";
        case "Pending":
          return "order-item__status--waiting";
        default:
          return "";
      }
    };

    const gotoDetail = (order) => {
      if (!order || !order.increment_id) {
        return;
      }
      const routerOrderDetail = app.localeRoute({
        name: "customer-single-order",
        params: {
          orderId: order.increment_id,
        },
      });
      router.push(routerOrderDetail);
    };

    return {
      changeTime,
      orders,
      error,
      checkOrderStatus,
      loading,
      gotoDetail,
      getStatusClass,
      totalOrder,
      loadOrderByPage,
      currentPage,
      totalPages,
      goToPage,
    };
  },
});
